import { render, staticRenderFns } from "./TagPickerModal.vue?vue&type=template&id=108f6873&scoped=true&"
import script from "./TagPickerModal.vue?vue&type=script&lang=js&"
export * from "./TagPickerModal.vue?vue&type=script&lang=js&"
import style0 from "./TagPickerModal.vue?vue&type=style&index=0&id=108f6873&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108f6873",
  null
  
)

export default component.exports